









































































































































































































































































































































import { createComponent, reactive, ref } from "@vue/composition-api";
import loginLogo from "@/assets/svg/loginLogo.svg";
import axios from "axios";

enum Page {
  Form,
  Confirm,
  PostRequest
}

export default createComponent({
  setup(props: {}, context: any) {
    const axiosInstance = axios.create({
      baseURL: `${process.env.VUE_APP_API_SERVER}`
    });
    const form = ref<null | { validate: () => null }>(null);

    const rules = {
      required: (value: string) => !!value || "入力必須項目です",
      max20: (value: string) => value.length <= 20 || "20文字までです",
      max60: (value: string) => value.length <= 60 || "60文字までです",
      max100: (value: string) => value.length <= 100 || "100文字までです",
      hanKakuKataKana: (value: string) =>
        /^[ｦ-ﾟ]*$/.test(value) || "半角カタカナで入力して下さい",
      email: (value: string) =>
        /[^\s@]+@[^\s@]+\.[^\s@]+/.test(value) || "不正なEメール形式です",
      phone: (value: string) =>
        /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value) ||
        "ハイフンを除き半角数字のみ入力して下さい",
      yyyymmdd: (value: string) =>
        /^[0-9]{8}$/.test(value) ||
        "1990年1月1日の場合　'19900101'と入力して下さい",
      zipCode: (value: string) =>
        /^[0-9]{7}$/.test(value) || "ハイフンを除いた７桁の数字で入力して下さい"
    };

    const empTypeItems: string[] = [
      "社員",
      "契約社員/アルバイト/パートなど",
      "派遣スタッフ",
      "個人事業主／フリーランス",
    ];

    const formParams = {
      company_name: {
        label: "企業名",
        hint: "",
        rule: [rules["required"], rules["max20"]]
      },
      department_name: {
        label: "部署名・店舗名",
        hint: "",
        rule: [rules["required"], rules["max20"]]
      },
      employee_type: {
        label: "従業員区分",
        hint: "",
        rule: [rules["required"]]
      },
      employee_number: {
        label: "社員番号",
        hint: "",
        rule: [rules["required"], rules["max20"]]
      },
      last_name: {
        label: "姓",
        hint: "",
        rule: [rules["required"], rules["max60"]]
      },
      first_name: {
        label: "名",
        hint: "",
        rule: [rules["required"], rules["max60"]]
      },
      last_name_kana: {
        label: "セイ",
        hint: "",
        rule: [rules["required"], rules["max60"], rules["hanKakuKataKana"]]
      },
      first_name_kana: {
        label: "メイ",
        hint: "",
        rule: [rules["required"], rules["max60"], rules["hanKakuKataKana"]]
      },
      gender_code: {
        label: "性別",
        hint: "",
        rule: [rules["required"]]
      },
      birthday: {
        label: "生年月日",
        hint: "",
        rule: [rules["required"], rules["yyyymmdd"]]
      },
      zip_code: {
        label: "郵便番号",
        hint: "",
        rule: [rules["required"], rules["zipCode"]]
      },
      address_1: {
        label: "都道府県　市区町村　番地",
        hint: "都道府県と市区町村と番地を入力して下さい。",
        rule: [rules["required"], rules["max60"]]
      },
      address_2: {
        label: "建物名　部屋番号",
        hint: "建物名と部屋番号を入力して下さい",
        rule: [rules["required"], rules["max60"]]
      },
      phone_number: {
        label: "携帯電話番号",
        hint: "",
        rule: [rules["required"], rules["phone"]]
      },
      mail_address: {
        label: "メールアドレス",
        hint: "",
        rule: [rules["required"], rules["max100"], rules["email"]]
      }
    };

    // Reactive State
    const state = reactive({
      currentPage: Page.Form,
      dialog: false,
      loading: false,
      errorMsg: {
        sendRequest: "",
        autoInputAddress: ""
      },

      formValues: {
        company_name: "",
        department_name: "",
        employee_type: "",
        employee_number: "",
        first_name: "",
        last_name: "",
        first_name_kana: "",
        last_name_kana: "",
        gender_code: "",
        birthday: "",
        zip_code: "",
        address_1: "",
        address_2: "",
        phone_number: "",
        mail_address: ""
      }

      // // 開発用デフォルト値
      // formValues: {
      //   company_name: "サンプル会社",
      //   department_name: "サンプル部署",
      //   employee_type: "社員",
      //   employee_number: "000000000000",
      //   last_name: "田中",
      //   first_name: "太郎",
      //   last_name_kana: "ﾀﾅｶ",
      //   first_name_kana: "ﾀﾛｳ",
      //   gender_code: "1",
      //   birthday: "20220903",
      //   zip_code: "5342243",
      //   address_1: "サンプル町1-1",
      //   address_2: "サンプルハイツ202",
      //   phone_number: "09044444444",
      //   mail_address: "test@test.com",
      // },
    });

    let showPage = (page: Page) => {
      state.currentPage = page;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };

    let toConfirmPage = () => {
      if (form.value!.validate()) {
        showPage(Page.Confirm);
      }
    };

    const autoInputAddress = () => {
      axiosInstance
        .get("/info/address/" + state.formValues.zip_code + "/", {})
        .then(response => {
          if (typeof response.data.state === "undefined") {
            state.errorMsg.autoInputAddress =
              "郵便番号に該当する住所がありません";
          } else {
            state.errorMsg.autoInputAddress = "";
            state.formValues.address_1 =
              response.data.state +
              " " +
              response.data.city +
              " " +
              response.data.town;
          }
        })
        .catch(error => {
          console.log("ERROR: in autoInputAddress():");
          console.log(error);
          state.errorMsg.autoInputAddress =
            "郵便番号に該当する住所がありません";
        })
        .finally();
    };

    let sendRequest = () => {
      state.loading = true;

      axiosInstance
        .post("/entry/card-reissue/", state.formValues, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(response => {
          state.loading = false;
          state.dialog = false;
          showPage(Page.PostRequest);
        })
        .catch(error => {
          console.log("error : ");
          console.log(error);
          state.loading = false;
          state.errorMsg.sendRequest = error;
        });
    };

    return {
      state,
      Page,
      showPage,
      form,
      toConfirmPage,
      valid: false,
      empTypeItems,
      sendRequest,
      formParams,
      autoInputAddress
    };
  },
  components: {
    loginLogo
  }
});
